<template>
  <b-form class="price-form">
    <b-form-group label="Название абонемента">
      <b-form-input
        v-model="value.name"
        type="text"
        placeholder="Введите название абонемента"
      />
    </b-form-group>
    <b-form-group label="Стоимость абонемента">
      <b-input-group append="₽">
        <b-form-input
          v-model="value.value"
          type="text"
          placeholder="Введите стоимость абонемента"
        />
      </b-input-group>
    </b-form-group>
  </b-form>
</template>

<script>
import PriceModel from "@/components/Forms/Gym/models/priceModel";

export default {
  props: {
    value: {
      type: PriceModel,
      required: true
    }
  }
};
</script>
